import { Box, Stack, Typography, useTheme } from '@mui/material';
import { Loader, WorkflowGenerateIllustration } from '@diana/core';
import { WORKFLOWS_PAGE_NS } from './i18n';
import { useTranslation } from 'react-i18next';

export const WorkflowsGenerateEmptyView = () => {
  const { t } = useTranslation(WORKFLOWS_PAGE_NS);
  const { palette } = useTheme();

  return (
    <Stack py={4} px={10} alignItems="center">
      <Box mb={2}>
        <Loader simple progressProps={{ size: 28 }} />
      </Box>
      <Stack gap={1} mb={6} sx={{ textAlign: 'center' }}>
        <Typography variant="h2">{t('titles.craftWorkflow')}</Typography>
        <Typography color={palette.text.secondary}>{t('descriptions.craftWorkflow')}</Typography>
      </Stack>
      <WorkflowGenerateIllustration />
    </Stack>
  );
};
